import workspaceQuery from '../../queries/salesLedger/SalesInvoiceWorkspaceQuery.graphql';
import instanceQuery from '../../queries/salesLedger/SalesInvoiceQuery.graphql';
import defaultQuery from '../../queries/salesLedger/SalesInvoiceDefault.graphql';
import mutationQuery from '../../mutations/salesLedger/SalesInvoiceMutation.graphql';
import temporaryMutationQuery from '../../mutations/salesLedger/SaveSalesInvoiceTempMutation.graphql';
import aggregateQuery from '../../queries/salesLedger/SalesInvoiceAggregateQuery.graphql';
import fragment from '../../fragments/salesLedger/SalesInvoiceFragment.graphql';
import SalesInvoicesReportMutation from '../../mutations/salesLedger/SalesInvoicesReportMutation.graphql';

import { formActionsForPermissions } from '../../../actions/salesLedger/salesInvoice/SalesInvoiceAction';
import * as printFunctions from '../../../actions/salesLedger/salesInvoice/SalesInvoiceWorkspaceAction';
import SalesInvoiceReportMutation from '../../mutations/salesLedger/SalesInvoiceReportMutation.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const SalesInvoice: EntityType = {
  type: 'SalesInvoice',
  title: 'Sales Invoices',
  formTitle: 'Sales Invoice',
  formUrl: '/Customers/Invoice/Details/',
  workspaceUrl: '/Customers/Invoice/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  aggregate: aggregateQuery,
  fragment,
  screenReference: 'SALES_LEDGER_INVOICES',
  actions: [...formActionsForPermissions, ...printFunctions.workspaceActionsForPermissions],
  printFunctions: printFunctions,
  generate: SalesInvoiceReportMutation,
  generateRange: SalesInvoicesReportMutation,
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
    remoteFilter: true,
  },
  configuration: {
    title: 'Sales Invoice',
    field: 'salesInvoiceDocumentDefault',
    reportType: ReportType.SalesInvoice,
    customerField: 'customerInvoiceDocumentDefault',
    receiveFlag: 'receiveInvoiceDocuments',
  },
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'CREDITED', 'REINVOICED'],
    },
  ],
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'payByLink',
      text: 'Pay by Link URL',
    },
    {
      key: 'paymentDueDate',
      text: 'Payment Due Date',
    },
    {
      key: 'salesOrderNumbers',
      text: 'Sales Order Numbers',
    },
    {
      key: 'shipmentName',
      text: 'Shipment Name',
    },
  ],
};

export default SalesInvoice;
